import React, { Component } from "react";

import UserImage from "../../../user_image";

class ListWinner extends Component {
  state = {};
  render() {
    if (!this.props.winner) return <div />;
    return (
      <div className="row max_width_500">
        <div
          className="width_image_question give_away_user"
          style={{
            marginTop: "2.5px",
            marginLeft: "2.5px",
            maxWidth: "60px",
            width: "60px"
          }}
          onClick={this.goToUserPage}
        >
          <UserImage
            user={this.props.winner}
            bottomImage={false}
            link={false}
          />
        </div>

        <div
          className="width_text_question btn cursor_btn align_element "
          onClick={this.goToUserPage}
        >
          <div className="cursor_btn width_100">
            <label
              className="cursor_btn user_name"
              style={{
                marginTop: "2px",
                fontSize: "14px",
                fontFamily: "DIN Pro Black",
                textTransform: "uppercase"
              }}
            >
              {this.props.winner.first_name} {this.props.winner.last_name}
            </label>
            <label
              className="cursor_btn user_username yaystack_color"
              style={{
                marginTop: "-5px",
                fontSize: "12px"
              }}
            >
              {this.props.winner.username}
            </label>
          </div>
        </div>
      </div>
    );
  }

  goToUserPage = event => {
    event.preventDefault();
    this.props.history.push(`/users/${this.props.user.username}`);
  };
}

export default ListWinner;



// WEBPACK FOOTER //
// ./src/components/list/interface/winner/list_winner.jsx